import { Component, OnInit, ViewChild } from '@angular/core';
import { SearchComponent } from '../../../base/search/search.component';
import { HtmlContentSearchResult } from '../../../../models/net/result/html-content-search-result';
import { SearchMarqueeComponent } from '../../../fragments/search-marquee/search-marquee.component';
import { AppService } from '../../../../services/app.service';
import { SessionService } from '../../../../services/session/session.service';
import { HtmlContentService } from '../../../../services/html-content/html-content.service';
import { HtmlContentEnvelope } from '../../../../models/net/envelope/html-content-envelope';
import { HtmlContentSearchRequest } from '../../../../models/net/request/html-content-search-request';
import { SearchRequestEnvelope } from '../../../../models/net/envelope/search-request-envelope';
import { SearchPreference } from '../../../../models/data/app-core/search-preference';
import { SearchRequestTypeEnum } from '../../../../enums/search-request-type-enum';

@Component({
    selector: 'app-html-contents',
    templateUrl: './html-contents.component.html',
    styleUrls: ['./html-contents.component.css', '../../../../app.component.css']
})

export class HtmlContentsComponent extends SearchComponent implements OnInit {

    public displayedColumns: string[] = ["Avatar", "Name", "Description", "CreatedOnUTC", "Delete"];
    public override searchResult: HtmlContentSearchResult[] = [];
    public searchRequestEnvelopes: HtmlContentEnvelope[] = [];
    public searchRequestTypeName: string = "SearchRequestEnvelope";
    public searchRequestTileComponentTypeName: string = "SearchTileComponent";

    @ViewChild("searchMarquee") searchMarquee!: SearchMarqueeComponent;

    public constructor(public override appService: AppService, public override sessionService: SessionService, public override itemService: HtmlContentService) { 

        super(appService, sessionService, itemService, "content", "HtmlContent");
        super.searchRequestTypeEnum = SearchRequestTypeEnum.HtmlContentSearchRequest;
    }

    public override ngOnInit(): void {

        super.ngOnInit();

        this.isSearchMarqueeDisabled = false;
    }

    public ngAfterViewInit(): void {

        this.searchMarquee!.runSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            const searchRequest: HtmlContentSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            this.runSearch(searchRequest);
        });

        this.searchMarquee!.runSavedSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            var resourceSearchRequest: HtmlContentSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            if (resourceSearchRequest) {

                this.runSearch(resourceSearchRequest);
            }
        });
    }

    public override handleSearchPreference(searchPreference: SearchPreference): void {

        if (searchPreference.SearchPreferenceId > 0) {

            if (searchPreference.DefaultSearchRequestId) {

                this.searchMarquee!.isSavedSearchMode = true;

                this.searchMarquee!.setDefaultSearchRequestId(searchPreference.DefaultSearchRequestId);

                if (searchPreference.IsRunDefaultSearchOnLoad) {

                    this.searchMarquee!.searchRequested();
                }
            }

        } else {

            this.searchMarquee!.isSavedSearchMode = false;
        }

        this.isSearchMarqueeDisabled = false;
    }

    public override getItemIndexFromSearchResult = (id: number): number | undefined => {

        const result = this.searchResult.map((i: HtmlContentSearchResult) => i.HtmlContentId).indexOf(id, 0);

        return result;
    }

    public runSearch = (searchRequest: HtmlContentSearchRequest): void => {

        this.searchRequest = searchRequest;

        this.search();
    }
}
